import { render } from "./Resume2.vue?vue&type=template&id=3f6aff2e&scoped=true"
import script from "./Resume2.vue?vue&type=script&lang=js"
export * from "./Resume2.vue?vue&type=script&lang=js"

import "./Resume2.vue?vue&type=style&index=0&id=3f6aff2e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3f6aff2e"

export default script